import axios from 'axios';


// Création de l'instance Axios avec la configuration de base

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Remplace avec ton URL de backend
  timeout: 10000, // Temps d'attente maximal en ms
  headers: {
    'Content-Type': 'application/json',
    'x-api-key' :  `Bearer ${process.env.REACT_APP_API_KEY}`
  },
});


apiClient.interceptors.request.use(
  
  (config) => {

    const token = localStorage.getItem('token');

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;
      
    }
    
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient